<template lang="pug">
  .columns
    .column.is-12(v-show="consumibles.length > 0")
      .table-responsive
        table#tbAsignaciones.table.is-striped.is-fullwidth
          thead
            tr
              th Descripción
              th Entrega
              th Traslada
              th Recibe
              th Destino
              th Cantidades
                span.tag.is-warning E
                | &nbsp
                span.tag.is-danger T
                | &nbsp
                span.tag.is-black R
          tbody
            tr(v-for="(data, index) in consumibles" :key="data.id")
              td
                span.tag.is-black {{ data.descripcion }}
                br
                span.tag.is-light Marca: {{ data.marca }}
                span.tag.is-light(v-show="data.modelo !==''") Modelo:  {{ data.modelo }}
              td
                span.tag.is-light {{ data.entrega }}
                | &nbsp
                a.button.is-small.is-rounded(@click="firmar(data, 1)" :class="data.firma_entrega===''? 'is-warning' : 'is-success'")
                  i.fas.fa-signature
              td
                span.tag.is-warning {{ data.traslada }}
                | &nbsp
                a.button.is-small.is-rounded(@click="firmar(data, 2)" :class="data.firma_traslada===''? 'is-warning' : 'is-success'")
                  i.fas.fa-signature
              td
                span.tag.is-black {{ data.recibe }}
                | &nbsp
                a.button.is-small.is-rounded(@click="firmar(data, 3)" :class="data.firma_recibe===''? 'is-warning' : 'is-success'")
                  i.fas.fa-signature
              td
                span.tag.is-light {{ data.destino }}
              td
                span.tag.is-warning {{ data.cantidad_e }}
                | &nbsp
                span.tag.is-danger {{ data.cantidad_t }}
                | &nbsp
                span.tag.is-black {{ data.cantidad_r }}
                | &nbsp
                a.button.is-small.is-danger.is-rounded(@click="imprimirSalida(data)")
                  i.fas.fa-print
    .column.is-12(v-show="consumibles.length < 1")
      span.tag.is-large No hay consumibles de traspaso en esta fecha.
</template>

<script>
  export default {
    name: 'TbTraspasosCons',
    props: {
      consumibles: {
        type: Array,
        default: [],
      },
    },
    methods: {
      firmar (data, estado) {
        const myObj = {
          data,
          estado
        }
        this.$emit('firmarConsumible', myObj)
      },
      imprimirSalida(data) {
        this.$emit('imprimir', data)
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/Tb_TraspasosCons.vue